/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_No_Active_TripInputs */

const vi_dashboard_driver_no_active_trip = /** @type {(inputs: Dashboard_Driver_No_Active_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có chuyến đang giao.`)
};

/**

* @param {Dashboard_Driver_No_Active_TripInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_no_active_trip = /** @type {((inputs?: Dashboard_Driver_No_Active_TripInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_No_Active_TripInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_no_active_trip(inputs)
});